<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
          v-if="showAddObjective"
          class="bg-black fixed bg-opacity-70 inset-0 z-50 h-auto w-full overflow-x-scroll"
      >
        <div
            class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-2/3 w-full m-auto"
        >
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base font-bold">Add Key Objectives</p>
            <img
                v-if="!loading"
                class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
                src="@/assets/icons/cross-white.png"
                @click="close()"
            />
          </div>
          <transition name="fade">
            <div
                v-if="inputError"
                class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ inputError }}
            </div>
          </transition>
          <div class="grid grid-cols-2 p-4 gap-5">

            <div class="text-sm ">
              <div class="flex justify-between">
                <label class="block pb-1">Objective </label>
                <label class="text-red-400 cursor-pointer pb-1" @click="handleResetAddNewObjective">Reset </label>
              </div>

              <div v-if="!isAddingGoal">
              <select
                  v-model="info.Objective"
                  class="p-2 bg-gray-200 rounded-full w-full"
                  @change="handleGoalChange"
              >
                <option disabled> Select Strategic Goal</option>
                <option
                    v-for="goal in strategicGoals"
                    :key="goal.Id"
                    :value="goal.Name"
                >
                  {{ goal.Name }}
                </option>
                <option value="add_new">+ Add New Strategic Goal</option>
              </select>
              </div>
              <div v-else>
              <input
                  type="text"
                  class="p-2 bg-gray-200 rounded-full w-full"
                  placeholder="Enter new strategic goal"
                  v-model="info.Objective"

              />
              </div>
            </div>
            <div class=" text-sm">
              <!-- {{ strategicGoals }} -->
              <label class="block pb-1">Progress /  Status</label>
              <input
                  type="text"
                  class="p-2 bg-gray-200 rounded-full w-full"
                  placeholder="Progress"
                  v-model="info.Progress"
              />
            </div>
          </div>
          <div class="grid grid-cols-2 p-4 gap-5">
          <div class="mt-2 ">
            <!-- {{ strategicGoals }} -->
            <label class="block pb-1">Achievements</label>
            <textarea
                v-model="info.Achievements"
                class="p-2 bg-gray-200 rounded-xl w-full"
                rows="4"
            ></textarea>
          </div>
          <div class="mt-2 ">
            <!-- {{ strategicGoals }} -->
            <label class="block pb-1">Challenges</label>
            <textarea
                v-model="info.Challenges"
                class="p-2 bg-gray-200 rounded-xl w-full"
                rows="4"
            ></textarea>
          </div>
          <div class="mt-2 ">
            <!-- {{ strategicGoals }} -->
            <label class="block pb-1">Actions</label>
            <textarea
                v-model="info.Actions"
                class="p-2 bg-gray-200 rounded-xl w-full"
                rows="4"
            ></textarea>
          </div>
            <div class="mt-2">
              <!-- {{ strategicGoals }} -->
              <label class="block pb-1">Steps</label>
              <textarea
                  v-model="info.Steps"
                  class="p-2 bg-gray-200 rounded-xl w-full"
                  rows="4"
              ></textarea>
            </div>
          </div>

          <!-- {{ info }} -->
          <div class="flex justify-end">
            <div class="flex justify-end p-5">
              <button
                  class="bg-primary rounded-full px-5 text-sm text-white py-3"
                  @click="submitObjective"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import axios from "axios";

export default {
  name: 'AddKeyObjectives',
  props: ['showAddObjective'],

  data() {
    return {
      loading: false,
      inputError:'',
      strategicGoals: [],
      reviewPeriods: [],
      info: {
        Objective: '',
        Progress: '',
        Achievements: '',
        Challenges: '',
        Actions: '',
        Steps: '',
      },
      activePeriod: null,
      isAddingGoal: false,
    };
  },
  computed: {
    ...mapGetters(['getOrganization', 'getToken']),
    displayValue() {
      return this.isFocused ? this.rawInput : `${this.info.GoalWeight}%`;
    },
  },
  created() {
    this.getPerformancePeriodSetups();
  },
  methods: {
    close() {
      this.$emit('close');
      this.clearForm();
    },
    handleGoalChange(){
      if (this.info.Objective === 'add_new') {
        this.isAddingGoal = true;
        this.info.Objective = '';
      } else {
        this.isAddingGoal = false;
      }
    },
    handleResetAddNewObjective(){
      this.isAddingGoal = false
      this.info.Objective = ""
    },
    clearForm(){
      this.info = {
        Objective: '',
        Progress: '',
        Achievements: '',
        Challenges:'',
        Actions: '',
        Steps:''

      };
    },
    getPerformancePeriodSetups() {
      this.loading = true;
      let url = `${this.getOrganization}/performance/period/${this.$ApiVersion}/request`;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios.get(url, options).then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.reviewPeriods = response.data.Data;
              this.activePeriod = this.reviewPeriods.find(
                  (period) => period.Active == true
              );
              this.getStrategicGoals();
            } else {
              this.$notify.error({
                title: 'Failure',
                message: response.StatusMessage,
              });
            }
          },
          (error) => {
            this.loading = false;
            this.$notify.error({ title: 'Failure', message: error.message });
          }
      );
    },
    getStrategicGoals() {
      // alert(1);
      this.loading = true;
      let url = `${this.getOrganization}/performance/strategic/goal/${this.$ApiVersion}/request`;

      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios.get(url, options).then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.strategicGoals = response.data.Data.filter(
                  (goal) =>  goal.ReviewPeriod === this.activePeriod.Name
              );
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
      );
    },
    submitObjective(){
      this.$emit('add-objective', {...this.info});
      this.clearForm();
    }
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>